export default `project_id_prefix
    project_id
    name
    description
    project_status_id
    project_status_updated_at
    project_director_id
    project_manager_id
    lead_technician_id
    project_charge_type_id
    rate_type_id
    first_timesheet_date
    project_associated_disciplines{
      project_discipline_id
      description
    }
    land_use_id
    total_budget
    total_fees
    total_invoiced
    total_credit_notes
    total_writeoff
    total_supplier_invoiced
    amount_to_invoice
    total_expenditure
    profit
    percent_profit
    amount_left_to_invoice
    percent_budget_used
    fee_rates{
      project_id
      active_from_date
      hourly_rate
    }
    project_activity_budgets{
      id
      project_activity_type_id
      budget_total
      budget_used
      supplier_total
      project_activity_type{
        description
      } 
      description
      address_id
      address{
        full_address
      }
      stage
      budget_label
      breakdown{
        id
        description
        amount
      }
    }
    users_time_on_project{
      user_id
      first_name
      last_name
      total_minutes_worked
      expenditure
    }
    users_time_on_project_last_seven_days{
      user_id
      first_name
      last_name
      total_minutes_worked
      timesheet_date
    }
    project_clients{
      client{
        client_id
        name
        client_contacts: project_client_contacts(project_id: $project_id){
            contact_id
            first_name
            last_name
            position
            contact_communication_methods{
                contact_info
                contact_medium{
                    contact_medium_id
                    description
                }
            }
        }
      }
      address{
        address_id
        name
        full_address
      }
    }
    project_addresses{
      address_id
      name
      full_address
      latitude
      longitude
    }
    notes{
      id
      user_id
      user{
        full_name
      }
      note
      date_created
      comments{
        id
        user_id
        user{
          full_name
        }
        note
        date_created
      }
    }
    writeoffs{
      id
      description
      amount
      written_off_at
      created_by_user{
        user_id
        full_name
      }
      project_activity_budget_id
      project_activity_budget{
        id
        description
        project_activity_type{
          project_activity_type_id
          description
        }
        stage
        address{
          full_address
        }
      }
    }
    invoices{
      id
      invoice_number
      client{
        client_id
        name
      }
      issued_at
      paid_at
      created_at
      invoice_url
      breakdown{
        id
        amount
      }
      credit_notes{
        id
        invoice_number
        created_at
        invoice_url
        breakdown{
          id
          amount
        }
      }
    }
    supplier_invoices{
      id
      invoice_number
      client{
        client_id
        name
      }
      issued_at
      paid_at
      created_at
      invoice_url
      invoice_total
      breakdown{
        id
        amount
        project_activity_budget{
            id
            description
            project_activity_type{
              project_activity_type_id
              description
            }
            stage
            budget_label
            address{
              full_address
            }
          }
      }
    }
    contract_status_id
    expenses{
      id
    	user{
        full_name
      }
      expense_at
      destination
      description
      expense_type
      expense_type_obj{
        id
        description
      }
      net
      vat
      gross
      created_at
      paid_at
      file_path
    }
    `